import React from 'react';
import { motion } from 'framer-motion';
import { FlaskConical, ShieldCheck, Leaf } from 'lucide-react';
export function TrustSection() {
  return <section className="py-28 md:py-32 bg-white border-b border-slate-100" data-id="element-409">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-410">
        <div className="text-center mb-20" data-id="element-411">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl font-serif font-bold text-slate-900" data-id="element-412">
            Qualität, der Sie vertrauen können
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-413">
          {[{
          icon: FlaskConical,
          title: 'Laborgeprüft',
          text: 'Jede Produktionscharge wird von unabhängigen Laboren auf Reinheit, Wirkstoffgehalt und Schwermetalle getestet.'
        }, {
          icon: ShieldCheck,
          title: 'Hergestellt in der EU',
          text: 'Produziert in einer GMP-zertifizierten Anlage nach strengsten europäischen Qualitätsstandards.'
        }, {
          icon: Leaf,
          title: 'Frei von unnötigen Zusatzstoffen',
          text: 'Keine Füllstoffe, keine künstlichen Farbstoffe, kein Magnesiumstearat. Nur das, was wirkt.'
        }].map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex flex-col items-center text-center group" data-id="element-414">
              <div className="relative mb-8" data-id="element-415">
                <div className="absolute inset-0 bg-brand-100/50 rounded-full blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-416" />
                <div className="relative w-24 h-24 bg-white rounded-full flex items-center justify-center shadow-sm border border-slate-200 group-hover:border-brand-200 transition-colors duration-300" data-id="element-417">
                  <div className="absolute inset-2 rounded-full border border-dashed border-brand-100" data-id="element-418" />
                  <item.icon className="w-10 h-10 text-brand-500" strokeWidth={1.5} data-id="element-419" />
                </div>
              </div>

              <h3 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-420">
                {item.title}
              </h3>
              <p className="text-slate-600 text-base leading-loose max-w-sm" data-id="element-421">
                {item.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}